import axios from "axios";
import { BaseURL } from "../../Utils/baseURL";

export const fetchTreeData = async () => {
  // Check if the data is already in sessionStorage
  const cachedData = sessionStorage.getItem('treeData');
  
  if (cachedData) {
    // If data exists in sessionStorage, return it directly
 
    return JSON.parse(cachedData);  // Parse and return the cached data
  }

  try {
    // Fetch data from API if not available in sessionStorage
    const response = await axios.get(`${BaseURL}/survey/tree-surveys/list`);

    if (response.data.status === "success") {
      const data = response.data.data.features;

      // Store the fetched data in sessionStorage for future use
      sessionStorage.setItem('treeData', JSON.stringify(data));

      return data;  // Return the fetched data
    }

    console.error("Failed to fetch tree data.");
    return [];  // Return an empty array if the API call fails
  } catch (error) {
    console.error("Error fetching tree data:", error);
    return [];  // Return an empty array in case of error
  }
};
